module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jeff Campbell would like to thank:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mary Jacobs for editing this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hunter Herring for writing the story “Railway Employees: Into the Jaws of Death,” researching “New Number Same Result” and writing “The 1914 Woodlake Interurban Wreck.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Austin Ng for researching and writing “The Mystery of John H. Dillehay’s Death” and researching for “The Costs of Cost Cutting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Debbie Calvin for her assistance in assembling the "), _c('i', [_vm._v("Mayhem on the Interurban")]), _vm._v(" exhibit for the Interurban Railway Museum and the photographic research for this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Druce Reiley Associates and the creative team at the Interurban Railway Museum for the museum exhibit "), _c('i', [_vm._v("Mayhem on the Interurban")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cheryl Smith and the Haggard Library for their research assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harold Larson, president of the board of the Plano Conservancy for Historic Preservation, for his support of this project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And "), _c('a', {
    attrs: {
      "href": "http://www.Newspapers.com",
      "target": "_blank"
    }
  }, [_vm._v("Newspapers.com")]), _vm._v(", an excellent resource for anyone conducting historical research.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 69
// module chunks = 0